import React from 'react';
import clsx from 'clsx';
import Image from 'next/image';

import { toDollars } from '@utils/money';
import { BaseComponentProps } from '@utils/types/baseComponents';
import RoveLogo from '@assets/images/rove.svg';
import AirbnbLogo from '@assets/images/airbnb.svg';

import styles from './styles.module.scss';

type Props = {
  amount: number;
} & BaseComponentProps;

export function AirbnbComparison(props: Props) {
  const { amount, containerStyle } = props;

  if (!amount) return null;

  return (
    <div className={clsx([styles.airbnbComparison, containerStyle])}>
      <div className={styles.airbnbComparison__text}>
        Properties on Rove are priced on average 5% less than Airbnb. The Airbnb
        price is an estimate.
      </div>

      <div className={styles.airbnbComparison__prices}>
        <div className={styles.airbnbComparison__logo}>
          <Image src={RoveLogo} alt="Rove Logo" width={79} height={18} />
        </div>
        <div
          className={styles.airbnbComparison__price}
          style={{
            width: '90%',
          }}
        >
          {toDollars(amount, 0)}
        </div>
      </div>

      <div className={styles.airbnbComparison__prices}>
        <div className={styles.airbnbComparison__logo}>
          <Image src={AirbnbLogo} alt="Airbnb Logo" width={92} height={30} />
        </div>
        <div
          className={clsx([
            styles.airbnbComparison__price,
            styles.airbnbComparison__priceAirbnb,
          ])}
          style={{
            width: '100%',
          }}
        >
          {toDollars(amount * 1.05, 0)}
        </div>
      </div>
    </div>
  );
}
